var render = function render(){var _vm=this,_c=_vm._self._c;return _c('myTable',{attrs:{"tableData":_vm.tableData,"columns":_vm.columns,"handleSizeChange":_vm.handleSizeChange,"handleCurrentChange":_vm.handleCurrentChange,"pageObj":_vm.pageObj,"border":false,"tableMaxHeight":680}})
}
var staticRenderFns = []

export { render, staticRenderFns }